/**
 * Агрегированная статистика пакетов Следов без координат (§П5.2).
 *
 * Назначение файла: для жалоб на геолокацию уходит только протокольная статистика.
 */

import type { GeoStatsPayload } from "../api/support.js";

let lastStats: GeoStatsPayload | null = null;

/** Обновляет статистику после отправки пакета точек (координаты не сохраняются). */
export function recordTraceBatchStats(input: {
  pointCount: number;
  avgAccuracyM: number;
  quarantineRatio: number;
  avgBatchIntervalMs: number;
}): void {
  lastStats = {
    pointCount: input.pointCount,
    avgAccuracyM: input.avgAccuracyM,
    quarantineRatio: input.quarantineRatio,
    avgBatchIntervalMs: input.avgBatchIntervalMs,
  };
}

export function getTraceTelemetry(): GeoStatsPayload | null {
  return lastStats;
}
